import React from 'react';
import iconSizes from 'constants/iconSizes.js';

const style = {
  display: 'inline-block',
  userSelect: 'none',
  flexShrink: 0,
};

const BroadcastIcon = ({ color = 'black', size = 'md', style: overrideStyles = {}, ...attr }) => {
  return (
    <svg style={{ ...style, ...overrideStyles }} viewBox="0 0 24 24" {...iconSizes[size]} fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 8.8346C13.4661 8.8346 14.6543 10.0572 14.6543 11.5655C14.6543 13.0718 13.4633 14.2961 12 14.2961C10.5384 14.2961 9.34563 13.0691 9.34563 11.5655C9.34563 10.0594 10.5379 8.8346 12 8.8346ZM18.3493 6.43161C17.6511 5.52833 18.9882 4.43486 19.6863 5.33815C22.8089 9.3734 22.7311 13.5979 19.693 17.6529C19.0083 18.5652 17.6576 17.4927 18.3427 16.5799C20.9014 13.1648 20.9821 9.83383 18.3493 6.43161ZM15.8924 8.42617C15.2241 7.49871 16.5949 6.45358 17.2629 7.3808C19.234 10.1273 19.2485 12.874 17.2629 15.6205C16.5949 16.5477 15.2241 15.5026 15.8924 14.5751C17.3742 12.5256 17.3633 10.4757 15.8924 8.42617ZM4.31386 5.33815C5.0118 4.43486 6.34883 5.52833 5.65065 6.43161C3.01812 9.83383 3.09881 13.1648 5.65753 16.5799C6.34242 17.4927 4.99163 18.5652 4.30698 17.6529C1.26888 13.5979 1.19104 9.37364 4.31386 5.33815ZM6.73707 7.3808C7.40535 6.45358 8.77584 7.49871 8.10756 8.42617C6.63693 10.4757 6.62577 12.5256 8.10756 14.5751C8.77584 15.5026 7.40535 16.5477 6.73707 15.6205C4.75147 12.874 4.76618 10.1273 6.73707 7.3808Z"
        fill={color}
      />
    </svg>
  );
};

export default BroadcastIcon ;
